import { Component, Input, OnInit } from '@angular/core';
import { ImportProgressService } from 'src/app/shared/import/import-progress.service';
import { ImportStep } from 'src/app/shared/import/import-step';
import { ProjectService } from 'src/app/shared/project/project.service';

@Component({
    selector: 'import-navigator',
    templateUrl: './import-navigator.component.html',
})
export class ImportNavigatorComponent implements OnInit {
    ImportStep: typeof ImportStep = ImportStep;   //hack for enum to be available in the template
    @Input() currentStep: string;
    @Input() showLastStep: boolean = true;
    maxStep: ImportStep = undefined;
    projectId: string;

    constructor (private importProgressService: ImportProgressService, private projectService: ProjectService) {}

    ngOnInit(): void {
        this.maxStep = ImportStep[this.currentStep as keyof typeof ImportStep];
        this.projectId = this.projectService.getProjectId();
        this.importProgressService.getImportStep().then(step => {
            this.maxStep = step;
        });
    }
}